import { z } from 'zod';
import { isoDateSchema } from './common.js';
export const analyticsRangeSchema = z.object({
    from: isoDateSchema.optional(),
    to: isoDateSchema.optional(),
});
export const setPlanSchema = z.object({
    plan: z.coerce.number().int().min(0).max(10_000),
});
//# sourceMappingURL=analytics.js.map